import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PhotoQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <g id='Layer 2'>
        <g id='image'>
          <path
            id='Vector'
            d='M12.3422 9.95372L13.1667 10.6571V9.57333V4C13.1667 3.69058 13.0438 3.39384 12.825 3.17504C12.6062 2.95625 12.3094 2.83333 12 2.83333H4C3.69058 2.83333 3.39383 2.95625 3.17504 3.17504C2.95625 3.39383 2.83333 3.69058 2.83333 4V11.8V12.8679L3.65353 12.184L8.50436 8.13943C8.50475 8.13911 8.50514 8.13879 8.50553 8.13847C8.74638 7.94075 9.04836 7.83266 9.36 7.83266C9.67078 7.83266 9.97195 7.94015 10.2125 8.13683L12.3422 9.95372ZM3.02529 13.1402C2.99572 13.1149 2.96705 13.0884 2.93934 13.0607C2.65804 12.7794 2.5 12.3978 2.5 12V4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5H12C12.3978 2.5 12.7794 2.65804 13.0607 2.93934C13.342 3.22064 13.5 3.60218 13.5 4V12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5H4C3.65529 13.5 3.32282 13.3814 3.05718 13.1667H4.37333H12C12.3094 13.1667 12.6062 13.0438 12.825 12.825C13.0438 12.6062 13.1667 12.3094 13.1667 12V11.3333V11.1024L12.9908 10.9526L9.98414 8.39263L9.97146 8.38183L9.95808 8.3719C9.78223 8.24133 9.56902 8.17083 9.35 8.17083C9.13098 8.17083 8.91777 8.24133 8.74192 8.3719L8.73056 8.38034L8.71969 8.3894L4.05303 12.2827L3.02529 13.1402Z'
            fill='white'
            stroke={props.stroke ?? '#3E8FFA'}
          />
          <path
            id='Vector_2'
            d='M5.83334 5.66667C5.83334 5.94281 5.60948 6.16667 5.33334 6.16667C5.05719 6.16667 4.83334 5.94281 4.83334 5.66667C4.83334 5.39053 5.05719 5.16667 5.33334 5.16667C5.60948 5.16667 5.83334 5.39053 5.83334 5.66667Z'
            fill='white'
            stroke={props.stroke ?? '#3E8FFA'}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
